module.exports = __webpack_public_path__ + "static/media/space-bg.7eafa473.jpg";